import {
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Select,
  TextInput,
} from "@mantine/core";
import { hasLength, useForm } from "@mantine/form";
import { custMeeting } from "../../../model/CustMeeting";
import { handleKeyDown } from "../../../_base/helper/FunctionHelper";
import { IconCheck } from "@tabler/icons-react";
import { repositoryMdm } from "../../../_base/_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";
import { useEffect, useState } from "react";
import {
  getCommuneSelectNew,
  getProvinceSelectNew,
} from "../../../service/getSelectApi";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { modals } from "@mantine/modals";

const EditCustMeeting = ({
  id,
  setDeleteViewStatus,
}: {
  id: any;
  setDeleteViewStatus: any;
}) => {
  const entity = {
    id: id,
    name: null,
    phone: null,
    province: null,
    provinceName: null,
    commune: null,
    communeName: null,
    district: null,
    districtName: null,
    street: null,
    streetName: null,
    additionalAddress: null,
  };

  const [dataProvinceSelect, setDataProvinceSelect] = useState<ComboboxItem[]>(
    [],
  );
  const [dataCommuneSelect, setDataCommuneSelect] = useState<ComboboxItem[]>(
    [],
  );

  const form = useForm<custMeeting>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },

    validate: {
      name: (value: string | null | undefined) => {
        if (!value) {
          return "Vui lòng nhập tên khách hàng !";
        }
      },
      phone: (value: string | null | undefined) => {
        if (value) {
          return hasLength(
            { max: 10, min: 8 },
            "Số điện thoại phải từ 8 đến 10 ký tự !",
          )(value as string);
        }
      },
      province: (value: number | null | undefined) => {
        if (!value) {
          return "Vui lòng chọn tỉnh/thành phố !";
        }
      },
      commune: (value: number | null | undefined) => {
        if (!value) {
          return "Vui lòng chọn phường/xã !";
        }
      },
    },
  });

  const getUpdate = async () => {
    const res = await repositoryMdm.get<MessageResponse<any>>(
      `/api/v1/TblWarrantyServiceRequestForm/update-meeting-customer?id=${id}`,
    );

    if (res && res?.success) {
      const result = res?.data;
      form.setValues(result);
      await getDataCommuneSelect(result?.province);
    }
  };

  const updateCustMeeting = async (dataSubmit: custMeeting) => {
    const res = await repositoryMdm.post<MessageResponse<any>>(
      "/api/v1/TblWarrantyServiceRequestForm/update-meeting-customer",
      dataSubmit,
    );

    if (res && res?.success) {
      NotificationExtension.Success(
        "Cập nhật thông tin khách hàng hẹn gặp thành công !",
      );
      setTimeout(() => {
        modals.closeAll();
        setDeleteViewStatus((prev: any) => !prev);
      }, 1000);
    }
  };

  const getDataProvinceSelect = async () => {
    const getData = await getProvinceSelectNew();
    setDataProvinceSelect(
      getData
        ?.filter((item: any) => item.id != null && item.name != null)
        ?.map((item: any) => ({
          value: String(item.id),
          label: String(item.name),
        })),
    );
  };

  const getDataCommuneSelect = async (province: any) => {
    if (province === null || province === undefined) return;
    const getData = await getCommuneSelectNew(String(province));
    const mapped =
      getData
        ?.filter((item: any) => item.value != null && item.text != null)
        ?.map((item: any) => ({
          value: String(item.value),
          label: String(item.text),
        })) ?? [];
    setDataCommuneSelect(mapped);

    // Phường/Xã lấy từ dữ liệu cũ có thể không map được sang dữ liệu API mới
    // -> nếu value không tìm thấy label trong danh sách vừa tải thì reset về null
    const commune = form.getValues()?.commune;
    if (
      commune !== null &&
      commune !== undefined &&
      !mapped.some((item: any) => String(item.value) === String(commune))
    ) {
      form.setValues((prev) => ({ ...prev, commune: null }));
    }
  };

  useEffect(() => {
    if (form.getValues()?.province !== null) {
      getDataCommuneSelect(form.getValues()?.province);
    }
  }, [form.getValues().province]);

  // Tỉnh/TP lấy từ dữ liệu cũ có thể không map được sang dữ liệu API mới
  // -> nếu value không tìm thấy label thì reset Tỉnh/TP và Phường/Xã về null
  useEffect(() => {
    const province = form.getValues()?.province;
    if (
      dataProvinceSelect.length > 0 &&
      province !== null &&
      province !== undefined
    ) {
      const isValid = dataProvinceSelect.some(
        (item) => String(item.value) === String(province),
      );
      if (!isValid) {
        form.setValues((prev) => ({
          ...prev,
          province: null,
          commune: null,
          additionalAddress: "",
        }));
      }
    }
  }, [dataProvinceSelect, form.getValues().province]);

  useEffect(() => {
    if (id) {
      getUpdate();
      getDataProvinceSelect();
    }
  }, [id]);

  return (
    <Box
      component="form"
      m={"5px 0px"}
      w={"30vw"}
      maw={500}
      onSubmit={form.onSubmit((e: custMeeting) => {
        updateCustMeeting(e);
      })}
    >
      <Grid>
        <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
          <TextInput
            label="Tên khách hàng"
            placeholder="Nhập tên khách hàng"
            key={form.key("name")}
            {...form.getInputProps("name")}
            withAsterisk
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
          <TextInput
            label="Số điện thoại"
            placeholder="Nhập số điện thoại"
            type="number"
            onKeyDown={handleKeyDown}
            key={form.key("phone")}
            {...form.getInputProps("phone")}
            withAsterisk
          />
        </Grid.Col>
      </Grid>
      <Grid>
        <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
          <Select
            label="Tỉnh/Thành phố"
            placeholder="Chọn tỉnh/thành phố"
            data={dataProvinceSelect}
            value={
              form.getValues().province
                ? form.getValues()?.province?.toString()
                : null
            }
            searchable
            clearable
            nothingFoundMessage="Không tìm thấy dữ liệu !"
            {...form.getInputProps("province")}
            onChange={(e) =>
              form.setValues((prev) => ({
                ...prev,
                province: e ? Number(e) : null,
                district: null,
                commune: null,
                street: null,
                additionalAddress: "",
              }))
            }
            withAsterisk
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
          <Select
            label="Phường/Xã"
            placeholder="Chọn phường/xã"
            data={dataCommuneSelect}
            searchable
            clearable
            disabled={form.getValues().province === null}
            value={
              form.getValues()?.commune
                ? form.getValues()?.commune?.toString()
                : null
            }
            {...form.getInputProps("commune")}
            onChange={(e) =>
              form.setValues((prev) => ({
                ...prev,
                commune: e ? Number(e) : null,
                street: null,
                additionalAddress: "",
              }))
            }
            nothingFoundMessage="Không tìm thấy dữ liệu !"
            withAsterisk
          />
        </Grid.Col>
      </Grid>
      <Grid>
        <Grid.Col span={12}>
          <TextInput
            label="Địa chỉ cụ thể"
            placeholder="Nhập địa chỉ cụ thể"
            disabled={form.getValues().commune === null}
            key={form.key("additionalAddress")}
            {...form.getInputProps("additionalAddress")}
          />
        </Grid.Col>
      </Grid>
      <Flex justify={"end"} gap={"md"} mt={10}>
        <Button
          type="submit"
          color="green"
          leftSection={<IconCheck size={14} />}
        >
          Lưu
        </Button>
      </Flex>
    </Box>
  );
};

export default EditCustMeeting;
